import { useMutation, useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import notifyingAction from "domainActions/notifyingAction";
import { updateEmailTemplates, fetchEmailTemplates } from "./EmailTemplatesAPI";
const handleUpdateEmailTemplates = notifyingAction({
  action: updateEmailTemplates,
  success: () => ({
    message: "Email Templates successfully edited!"
  }),
  error: (error) => ({
    message: `Error Editing: ${error}`
  })
});
const useEmailTemplate = () => {
  const { data: templateConfig = {} } = useQuery({
    queryKey: ["customization", "email-templates"],
    queryFn: fetchEmailTemplates
  });
  const { mutateAsync: _onUpdatePublicNotification } = useMutation({
    mutationFn: handleUpdateEmailTemplates
  });
  const onUpdateEmailTemplates = useCallback(
    (config) => _onUpdatePublicNotification(config),
    [_onUpdatePublicNotification]
  );
  return {
    templateConfig,
    onUpdateEmailTemplates
  };
};
export default useEmailTemplate;
